import { apiRequest } from './core/client';

export interface TriageEmailRecipient {
  name: string | null;
  email: string;
}

export interface TriageRecentEmail {
  id: string;
  subject: string | null;
  snippet: string | null;
  date: string;
  isRead: boolean;
  to: TriageEmailRecipient[];
  cc: TriageEmailRecipient[];
}

export interface TriageSenderGroup {
  key: string;
  accountId: string;
  accountIds?: string[]; // Present in unified view when sender spans multiple accounts
  senderEmail: string;
  senderName: string | null;
  contactId: string | null;
  contactApprovalState: 'pending' | 'approved' | 'blocked' | null;
  totalMessages: number;
  unreadCount: number;
  lastMessageDate: string;
  recentEmails: TriageRecentEmail[];
  avgPriorityScore: number | null;
}

export interface GetSenderGroupsResponse {
  senderGroups: TriageSenderGroup[];
  total: number;
}

/**
 * Get all sender groups for inbox triage mode
 */
export async function getSenderGroupsForTriage(
  accountId: string,
  folderId: string
): Promise<GetSenderGroupsResponse> {
  return await apiRequest<GetSenderGroupsResponse>({
    path: '/triage/sender-groups',
    method: 'POST',
    accountId,
    body: {
      folderId,
    },
  });
}

export interface SenderBulkActionResponse {
  processed: number;
  total_messages: number;
}

/**
 * Apply bulk action to all emails from a sender
 */
export async function applySenderBulkAction(
  accountId: string,
  folderId: string,
  senderEmail: string,
  action: 'archive' | 'delete',
  targetMailboxPath?: string,
  excludeMessageIds?: string[]
): Promise<SenderBulkActionResponse> {
  return await apiRequest<SenderBulkActionResponse>({
    path: '/senders/bulk-action',
    method: 'POST',
    accountId,
    body: {
      folderId,
      sender: { email: senderEmail },
      action,
      targetMailboxPath,
      excludeMessageIds,
    },
  });
}
